import * as core from '../../../../../../../core'

import { query } from './key-benefits-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'key.benefits.by.functional.area',
    description: 'Bar chart of key benefit change impacts by functional area',
    name: 'Key Benefits by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
